import { Address } from '@lib/resources/types';

export default function useAddressMobile(data?: { label: string; value: Address; key?: string; id?: string }) {
  if (!data) return { address: '', city: '', postcode: '' };
  const address = data?.value?.address;

  let initialCity = data?.value?.city;
  if (data?.value?.state) initialCity += `, ${data?.value?.state}`;
  const city = initialCity?.replace(/^,\s/, '');

  let initialPostcode = data?.value?.postcode;
  if (data?.value?.country) initialPostcode += `, ${data?.value?.country}`;
  const postcode = initialPostcode?.replace(/^,\s/, '');

  return { address, city, postcode };
}
